module.exports = __webpack_public_path__ + "static/media/header-image.ecb7447f.png";